import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getAdminToken, setAdminToken } from '../../utils/adminRequest';

const baseURL = process.env.REACT_APP_API_URL || '';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (getAdminToken()) navigate('/admin/activities', { replace: true });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/api/admin/login`, { username, password });
      if (res.data?.token) {
        setAdminToken(res.data.token);
        navigate('/admin/activities');
      }
    } catch (err) {
      setError(err.response?.data?.error || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      padding: 20
    }}>
      <div style={{
        width: '100%', maxWidth: 400,
        background: '#fff', borderRadius: 16, padding: 40,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <h1 style={{ textAlign: 'center', marginBottom: 8, color: '#333' }}>管理后台</h1>
        <p style={{ textAlign: 'center', color: '#666', fontSize: 14, marginBottom: 32 }}>请输入用户名和密码</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="用户名"
            autoFocus
            required
            style={{
              width: '100%', padding: '14px 16px', fontSize: 16,
              border: '1px solid #ddd', borderRadius: 8,
              boxSizing: 'border-box', marginBottom: 12
            }}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="密码"
            required
            style={{
              width: '100%', padding: '14px 16px', fontSize: 16,
              border: '1px solid #ddd', borderRadius: 8,
              boxSizing: 'border-box', marginBottom: 16
            }}
          />
          {error && <p style={{ color: '#e74c3c', fontSize: 14, marginBottom: 16 }}>{error}</p>}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: 14, fontSize: 16, fontWeight: 600,
              background: '#6366f1', color: '#fff', border: 'none',
              borderRadius: 8, cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? '验证中...' : '进入'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
